/**
 * Prefers an API `message` / `Message` field when present; otherwise returns the fallback.
 */
export function resolveApiErrorMessage(
  payload: unknown,
  fallback: string
): string {
  if (payload && typeof payload === "object") {
    const record = payload as Record<string, unknown>;
    const message = record.message ?? record.Message;
    if (typeof message === "string" && message.trim()) {
      return message.trim();
    }
  }
  return fallback;
}
